import { AllContent, Field, HorizRule, Img, List, Paragraph, Region, Group, SubReport, Table, SignatureBlock, TOC, Tag, PageBreak, Link } from "../core/pdf/types";
import { Icon } from "../core/ui/icons";
import { HREditor } from "./HREditor";
import { ImageEditor } from "./ImageEditor";
import { ListEditor } from "./ListEditor";
import { ParagraphHeadingEditor } from "./ParagraphHeadingEditor";
import { RegionEditor } from "./RegionEditor";
import { GroupEditor } from "./GroupEditor";
import { SubReportEditor } from "./SubReportEditor";
import { TableEditor } from "./TableEditor";
import { useDesigner } from "./useDesigner";
import { SignatureBlockEditor } from "./SignatureBlockEditor";
import { TOCEditor } from "./TOCEditor";
import { TagEditor } from "./TagEditor";
import { PageBreakEditor } from "./PageBreakEditor";
import { LinkEditor } from "./LinkEditor";

export function ContentItems(props: {
	content: AllContent[],
}) {
	const designer = useDesigner();

	function wrapWithStatus(component: any, c: AllContent | any) {
		if (!c.visibility && !c.continue) {
			return component;
		} else {
			let cls = "";
			if (c.visibility) cls += " text-brand-secondary";

			return (
				<div className={"relative" + cls} key={component.key}>
					<div style={{ position:"absolute", "left":"-20px" }}>
						{c.visibility && <Icon type="eye" />}
						{c.continue && <Icon type="continue" />}
					</div>
					{component}
				</div>
			)
		}
	}

	const items = [];
	for(let c of props.content) {
		if (!c.id) c.id = designer.nextID();

		if ((c.type === "p") || (c.type === "heading")) {
			// convert from segments to single html
			const p = c as Paragraph;
			if (p.html === undefined) {
				// build html from the segments
				const html = [];
				for(let s of p.segments) {
					if (!s.text) continue;
					
					let text = s.text;

					if (s.field) {
						const f = s as Field;
						if (!f.id) f.id = designer.nextID();

						text =
							'<span class="field-token" contentEditable="false" id="' + f.id + '"'
							+ " data-options='" + encodeURIComponent(JSON.stringify(f.field)) + "'>"
							+ text + "</span>"
						; 
					}

					// preserve spaces at start/end
					if (text.startsWith(" ")) text = "&nbsp;" + text.substring(1);
					if (text.endsWith(" ")) text = text.substring(0, text.length-1) + "&nbsp;"

					if (s.italic) text = "<i>" + text + "</i>";
					if (s.bold) text = "<b>" + text + "</b>";
					html.push(text);
				}
				p.html = html.join("");	
			}

			items.push(
				wrapWithStatus(<ParagraphHeadingEditor paragraph={p} key={c.id} />, c)
			);

		} else if (c.type === "list") {
			items.push(
				<ListEditor list={c as List} key={c.id} />
			);


		} else if (c.type === "table") {
			items.push(
				<TableEditor table={c as Table} key={c.id} />
			)

		} else if (c.type === "hr") {
			items.push(
				<HREditor hr={c as HorizRule} key={c.id} />
			)

		} else if (c.type === "group") {
			items.push(
				<GroupEditor group={c as Group} key={c.id} />
			)

		} else if (c.type === "region") {
			items.push(
				<RegionEditor region={c as Region} key={c.id} />
			)
		
		} else if (c.type === "image") {
			items.push(
				<ImageEditor image={c as Img} key={c.id} />
			)

		} else if (c.type === "sub-report") {
			items.push(
				<SubReportEditor subReport={c as SubReport} embedded={true} key={c.id} />
			)

		} else if (c.type === "sig-block") {
			items.push(
				<SignatureBlockEditor sig={c as SignatureBlock} key={c.id} />
			)

		} else if (c.type === "toc") {
			items.push(
				<TOCEditor toc={c as TOC} key={c.id} />
			);

		} else if (c.type === "tag") {
			items.push(
				<TagEditor tag={c as Tag} key={c.id} />
			);

		} else if (c.type === "pagebreak") {
			items.push(
				<PageBreakEditor pb={c as PageBreak} key={c.id} />
			);

		} else if (c.type === "link") {
			items.push(
				<LinkEditor link={c as Link} key={c.id} />
			);

		}

	}

	return (
		<div className="content">
			{items}
		</div>
	);
}
